(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    /* RoyalCare: the dimmed page around the floating cart drawer closes it instead of clicking through. */
  document.addEventListener(
    'click',
    function (event) {
      var drawer = document.getElementById('cart-drawer');
      var dialog = drawer && drawer.querySelector('dialog');
      if (!dialog || !dialog.open) return;
      if (dialog.contains(event.target)) return;
      if (event.target.closest && event.target.closest('cart-icon, .header-actions__cart-icon')) return;
      event.preventDefault();
      event.stopPropagation();
      if (typeof drawer.close === 'function') drawer.close();
    },
    true
  );

  /* RoyalCare: the checkout CTA opens the EasySell COD order form (when the app is active)
     instead of Shopify checkout. The drawer closes first so the form is not hidden behind it. */
  document.addEventListener(
    'click',
    function (event) {
      var cta = event.target instanceof Element ? event.target.closest('#cart-drawer .cart__checkout-button, .cart-page .cart__checkout-button') : null;
      if (!cta) return;
      /* Use the cart EasySell button (drawer or /cart page), never the product-page one: on product pages both exist with the same id. */
      var esButton = cta.closest('.cart-page')
        ? document.querySelector('.cart-page .es-popup-button-cart')
        : document.querySelector('#cart-drawer .es-popup-button-drawer') || document.querySelector('.es-popup-button-drawer');
      if (!esButton) return;
      event.preventDefault();
      event.stopPropagation();
      var drawer = document.getElementById('cart-drawer');
      if (drawer && typeof drawer.close === 'function') drawer.close();
      setTimeout(function () {
        esButton.click();
      }, 50);
    },
    true
  );

  /* RoyalCare: branded header for the EasySell COD form (logo, close button, title). */
  (function () {
    function phoneLine() {
      var holder = document.querySelector('[data-rc-shop-phone]');
      var phone = holder ? holder.getAttribute('data-rc-shop-phone') : '';
      if (!phone) return '';
      var tel = phone.replace(/[^0-9+]/g, '');
      return (
        '<span class="rc-es-head__phone">Vrei să comanzi telefonic? Sună la ' +
          '<a href="tel:' + tel + '"><i class="fa-solid fa-phone" aria-hidden="true"></i>' + phone + '</a>' +
        '</span>'
      );
    }

    function buildHeader() {
      var container = document.querySelector('#easysell-modal #es-form-container');
      if (!container || container.querySelector('.rc-es-head')) return;
      var logo = document.querySelector('.header-logo img, a.header-logo img, .header__logo img');
      var head = document.createElement('div');
      head.className = 'rc-es-head';
      head.innerHTML =
        '<div class="rc-es-head__bar">' +
          (logo
            ? '<img class="rc-es-head__logo" src="' + logo.currentSrc + '" alt="RoyalCare">'
            : '<span class="rc-es-head__brand">RoyalCare</span>') +
          '<button type="button" class="rc-es-head__close" aria-label="Închide formularul">' +
            '<svg viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="rc-es-head__text">' +
          '<strong class="rc-es-head__title">Ești la un pas de comandă!</strong>' +
          '<span class="rc-es-head__sub">Completează datele de livrare de mai jos!</span>' +
          phoneLine() +
        '</div>';
      container.insertBefore(head, container.firstChild);
    }

    document.addEventListener('click', function (event) {
      var target = event.target instanceof Element ? event.target : null;
      if (!target) return;
      if (target.closest('.rc-es-head__close')) {
        var original = document.querySelector('#easysell-modal .close-icon');
        if (original) original.click();
        return;
      }
      if (target.closest('.es-popup-button, #es-sticky, [data-rc-quick-order], #cart-drawer .cart__checkout-button')) {
        setTimeout(buildHeader, 60);
        setTimeout(buildHeader, 400);
      }
    });

    /* ===== Order summary for cart orders (closed by default) ===== */
    function money(cents) {
      var lei = cents / 100;
      return (Number.isInteger(lei) ? String(lei) : lei.toFixed(2).replace('.', ',')) + ' lei';
    }

    /* Drop ",00" from every whole-lei amount inside the EasySell form (184,00 lei -> 184 lei). */
    function stripZeros(root) {
      if (!root) return;
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        if (/,00(\s*lei)/.test(node.nodeValue)) {
          node.nodeValue = node.nodeValue.replace(/,00(\s*lei)/g, '$1');
        }
      }
    }

    function parseLei(text) {
      if (!text) return null;
      var clean = text.replace(/[^0-9,.]/g, '');
      if (!clean) return 0;
      if (clean.indexOf(',') > -1) clean = clean.replace(/\./g, '').replace(',', '.');
      return Math.round(parseFloat(clean) * 100);
    }

    function lineValue(container, selector) {
      var row = container.querySelector(selector);
      if (!row) return null;
      var cells = row.children;
      return cells.length ? cells[cells.length - 1].textContent.trim() : null;
    }

    function ensureToggle(container) {
      var toggle = container.querySelector('.rc-es-summary');
      if (toggle) return toggle;
      toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'rc-es-summary';
      toggle.setAttribute('aria-expanded', 'false');
      toggle.innerHTML =
        '<span class="rc-es-summary__label">Rezumat comandă<i class="fa-solid fa-chevron-down" aria-hidden="true"></i></span>' +
        '<span class="rc-es-summary__totals"><s data-rc-sum-was hidden></s><strong data-rc-sum-total></strong></span>';
      var head = container.querySelector('.rc-es-head');
      container.insertBefore(toggle, head ? head.nextSibling : container.firstChild);
      return toggle;
    }

    /* Full ("before") prices of the cart lines, computed ahead of time and cached. */
    var productCache = {};
    var full = { key: '', lines: null, pending: null };

    function cartKey(cart) {
      return cart.items
        .map(function (i) { return i.variant_id + 'x' + i.quantity + '=' + i.final_line_price; })
        .join('|');
    }

    function loadFull() {
      if (full.pending) return full.pending;
      full.pending = fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var key = cartKey(cart);
          if (key === full.key && full.lines) return full.lines;
          return Promise.all(cart.items.map(function (item) {
            var cached = productCache[item.handle];
            var request = cached
              ? Promise.resolve(cached)
              : fetch('/products/' + item.handle + '.js', { headers: { Accept: 'application/json' } })
                  .then(function (r) { return r.json(); })
                  .then(function (product) { productCache[item.handle] = product; return product; });
            return request
              .then(function (product) {
                var variant = (product.variants || []).find(function (v) { return v.id === item.variant_id; });
                var unit = item.original_price;
                if (variant && variant.compare_at_price > unit) unit = variant.compare_at_price;
                return { productId: item.product_id, full: unit * item.quantity, final: item.final_line_price };
              })
              .catch(function () {
                return { productId: item.product_id, full: item.original_price * item.quantity, final: item.final_line_price };
              });
          })).then(function (lines) {
            full.key = key;
            full.lines = lines;
            return lines;
          });
        })
        .catch(function () { return full.lines; })
        .then(function (lines) {
          full.pending = null;
          return lines;
        });
      return full.pending;
    }

    function setText(el, text) {
      if (el && el.textContent !== text) el.textContent = text;
    }

    function markLines(container, lines) {
      /* the automatic surprise gift (snippets/rc-gift-sync): shown like in the cart drawer */
      container.querySelectorAll('.es-line-item').forEach(function (row) {
        var title = row.querySelector('.es-product-title:not(.variant)');
        var isGift = !!title && /Cadou Surpriz/i.test(title.textContent);
        if (row.classList.contains('rc-es-gift') !== isGift) row.classList.toggle('rc-es-gift', isGift);
        if (isGift) {
          row.querySelectorAll('a.es-product-title-link, .es-product-title a, a[href*="/products/cadou-surpriza"]').forEach(function (link) {
            if (!link.hasAttribute('href')) return;
            link.removeAttribute('href');
            link.setAttribute('aria-disabled', 'true');
          });
        }
      });
      if (!lines) return;
      container.querySelectorAll('.es-line-item').forEach(function (row) {
        var id = parseInt(row.getAttribute('data-product-id'), 10);
        var fullSum = 0;
        var finalSum = 0;
        lines.forEach(function (line) {
          if (line.productId === id) {
            fullSum += line.full;
            finalSum += line.final;
          }
        });
        var priceCol = row.querySelector('.es-p-price');
        if (!priceCol) return;
        var tag = priceCol.querySelector('.rc-es-line-was');
        if (fullSum > finalSum) {
          if (!tag) {
            tag = document.createElement('s');
            tag.className = 'rc-es-line-was';
            priceCol.insertBefore(tag, priceCol.firstChild);
          }
          setText(tag, money(fullSum));
          if (!row.classList.contains('rc-has-full-price')) row.classList.add('rc-has-full-price');
        } else if (tag) {
          tag.remove();
          row.classList.remove('rc-has-full-price');
        }
      });
    }

    /* Fill the summary header instantly from the drawer's checkout button (total incl. shipping). */
    function prefillSummary(toggle) {
      var ctaTotal = document.querySelector('#cart-drawer .rc-cta__total, .cart-page .rc-cta__total');
      var totalCents = ctaTotal ? parseLei(ctaTotal.textContent) : null;
      if (!totalCents) return;
      setText(toggle.querySelector('[data-rc-sum-total]'), money(totalCents));
      var was = toggle.querySelector('[data-rc-sum-was]');
      if (full.lines) {
        var fullSum = full.lines.reduce(function (sum, line) { return sum + line.full; }, 0);
        var finalSum = full.lines.reduce(function (sum, line) { return sum + line.final; }, 0);
        var fullTotal = fullSum + (totalCents - finalSum);
        setText(was, money(fullTotal));
        was.hidden = !(fullTotal > totalCents);
      } else {
        was.hidden = true;
      }
    }

    function isCartMode(container) {
      if (container.querySelector('.es-quantity-offers')) return false;
      return !!container.querySelector('.es-line-item');
    }

    var lastRows = '';

    /* Guarantee box above the "notificări" checkbox (EasySell may re-render the form, so it is re-checked on every refresh). */
    function ensureTrust(container) {
      var anchor = null;
      container.querySelectorAll('.es-group').forEach(function (group) {
        if (!anchor && group.querySelector('input[type="checkbox"]') && /notific/i.test(group.textContent)) anchor = group;
      });
      if (!anchor) return;
      var box = container.querySelector('.rc-es-trust');
      if (box && box.nextElementSibling === anchor) return;
      if (!box) {
        box = document.createElement('div');
        box.className = 'rc-es-trust';
        box.innerHTML =
          '<span class="rc-es-trust__icon" aria-hidden="true"><i class="fa-solid fa-shield-heart"></i></span>' +
          '<p class="rc-es-trust__text"><mark>RETUR GRATUIT</mark> Dacă nu îți place produsul îl poți ' +
          'returna gratuit în <b>30 zile</b>, fără nicio întrebare!</p>';
      }
      anchor.parentNode.insertBefore(box, anchor);
    }

    /* Discount code: a collapsed "Ai un cod de reducere?" row (same as in the cart) that opens the field below it. */
    function ensureDiscount(container) {
      var group = container.querySelector('.es-discount-group');
      if (!group) return;
      group.classList.add('rc-es-disc');
      var toggle = group.querySelector(':scope > .rc-es-disc__toggle');
      if (!toggle) {
        toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'rc-es-disc__toggle';
        toggle.innerHTML =
          '<i class="fa-solid fa-ticket rc-es-disc__icon" aria-hidden="true"></i>' +
          '<span class="rc-es-disc__label">Ai un cod de reducere?</span>' +
          '<span class="rc-es-disc__plus" aria-hidden="true"></span>';
        group.insertBefore(toggle, group.firstChild);
      }
      var input = group.querySelector('.es-discount-input');
      var open = !!container.__rcDiscOpen || !!(input && input.value);
      group.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function refresh() {
      var container = document.querySelector('#easysell-modal #es-form-container');
      if (!container) return;
      stripZeros(container);
      ensureTrust(container);
      ensureDiscount(container);
      var toggle = ensureToggle(container);
      if (!isCartMode(container)) {
        var leftover = container.querySelector('.rc-es-sumrows');
        if (leftover) {
          leftover.remove();
          lastRows = '';
        }
        return;
      }

      var subtotal = lineValue(container, '.es-subt-line');
      var shipping = lineValue(container, '.es-shipping-line');
      var total = lineValue(container, '.es-total-line');
      if (!total) return;
      var shipCents = parseLei(shipping) || 0;
      var subtotalCents = parseLei(subtotal) || 0;
      var totalCents = parseLei(total) || 0;

      setText(toggle.querySelector('[data-rc-sum-total]'), money(totalCents));

      var lines = full.lines;
      if (lines) {
        var fullProducts = lines.reduce(function (sum, line) { return sum + line.full; }, 0);
        var was = toggle.querySelector('[data-rc-sum-was]');
        var showWas = fullProducts > subtotalCents;
        setText(was, money(fullProducts + shipCents));
        if (was.hidden === showWas) was.hidden = !showWas;
      }
      markLines(container, lines);

      /* A discount code is the difference between products + shipping and EasySell's total */
      var discCents = Math.max(0, subtotalCents + shipCents - totalCents);
      var discCode = '';
      var discInput = container.querySelector('.es-discount-input');
      if (discInput && discInput.value) discCode = discInput.value.trim().toUpperCase();

      var group = container.querySelector('.es-cart_content-group');
      if (group) {
        var rows = group.querySelector('.rc-es-sumrows');
        var html =
          '<div class="rc-es-sumrows__row"><span>Produse</span><span>' + money(subtotalCents) + '</span></div>' +
          '<div class="rc-es-sumrows__row"><span>Transport</span>' +
            (shipCents === 0 ? '<span class="rc-es-sumrows__free">Gratuit</span>' : '<span>' + money(shipCents) + '</span>') +
          '</div>' +
          (discCents > 0
            ? '<div class="rc-es-sumrows__row rc-es-sumrows__row--disc"><span><i class="fa-solid fa-ticket" aria-hidden="true"></i> Reducere' +
              (discCode ? ' <b>' + discCode.replace(/[<>&"]/g, '') + '</b>' : '') + '</span><span>-' + money(discCents) + '</span></div>'
            : '') +
          '<div class="rc-es-sumrows__row rc-es-sumrows__row--total"><span>Total</span><span>' + money(totalCents) + '</span></div>';
        if (!rows) {
          rows = document.createElement('div');
          rows.className = 'rc-es-sumrows';
          group.appendChild(rows);
          lastRows = '';
        }
        if (html !== lastRows) {
          rows.innerHTML = html;
          lastRows = html;
        }
      }
    }

    /* Re-run whenever EasySell re-renders the form (one pass per frame). */
    var scheduled = false;
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        refresh();
      }, 16);
    }

    function observeForm() {
      var container = document.querySelector('#easysell-modal #es-form-container');
      if (!container) return false;
      if (container.__rcObserved) return true;
      container.__rcObserved = true;
      ensureToggle(container);
      new MutationObserver(schedule).observe(container, { childList: true, subtree: true, characterData: true });
      schedule();
      return true;
    }

    /* Keep the full-price cache warm so the summary is complete as soon as the form opens. */
    document.addEventListener('shopify:cart:lines-update', function (event) {
      if (event.promise) event.promise.then(function () { loadFull(); }, function () {});
    });

    document.addEventListener('pointerdown', function (event) {
      var target = event.target instanceof Element ? event.target : null;
      if (target && target.closest('#cart-drawer .cart__checkout-button, .cart-page .cart__checkout-button, cart-icon, .header-actions__cart-icon')) loadFull();
    }, true);

    document.addEventListener('click', function (event) {
      var target = event.target instanceof Element ? event.target : null;
      if (!target) return;
      var discToggle = target.closest('.rc-es-disc__toggle');
      if (discToggle) {
        var discGroup = discToggle.closest('.es-discount-group');
        var discForm = discToggle.closest('#es-form-container');
        var discOpen = discGroup.classList.toggle('is-open');
        if (discForm) discForm.__rcDiscOpen = discOpen;
        discToggle.setAttribute('aria-expanded', discOpen ? 'true' : 'false');
        var discInput = discGroup.querySelector('.es-discount-input');
        if (discOpen && discInput) setTimeout(function () { discInput.focus(); }, 60);
        return;
      }
      var toggle = target.closest('.rc-es-summary');
      if (toggle) {
        var container = toggle.closest('#es-form-container');
        var open = container.classList.toggle('rc-summary-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        return;
      }
      if (target.closest('.es-popup-button, #es-sticky, [data-rc-quick-order], #cart-drawer .cart__checkout-button, .cart-page .cart__checkout-button')) {
        /* Every time the form opens, the summary starts closed. */
        var form = document.querySelector('#easysell-modal #es-form-container');
        if (form) {
          form.classList.remove('rc-summary-open');
          var fromCart = !!target.closest('#cart-drawer .cart__checkout-button, .cart-page .cart__checkout-button, .es-popup-button-drawer, .es-popup-button-cart');
          form.classList.toggle('rc-cart-order', fromCart);
          var t = ensureToggle(form);
          t.setAttribute('aria-expanded', 'false');
          if (fromCart && !target.closest('.es-popup-button-drawer, .es-popup-button-cart')) prefillSummary(t);
        }
        observeForm();
        loadFull().then(schedule);
      }
    }, true);

    document.addEventListener('DOMContentLoaded', function () {
      var tries = 0;
      var timer = setInterval(function () {
        tries += 1;
        buildHeader();
        var ready = observeForm();
        if ((ready && document.querySelector('.rc-es-head')) || tries > 40) clearInterval(timer);
      }, 300);
      setTimeout(loadFull, 1500);
    });
  })();

  /* RoyalCare: searchable county ("Județ") list in the EasySell COD form.
     The native select stays in the form (EasySell reads it, required validation keeps working);
     a searchable list is shown on top and writes the chosen value back into it. */
  (function () {
    var FIELDS = [
      { id: 'es-province', icon: 'bi bi-map', title: 'Selectează județul', search: 'Caută județul...', empty: 'Niciun județ găsit' }
    ];

    function normalize(text) {
      return (text || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
    }

    function placeholderText(select) {
      var first = select.options[0];
      return (first && first.value === '' ? first.text : '') || select.getAttribute('placeholder') || 'Județ';
    }

    function syncTrigger(wrap) {
      var select = wrap.__select;
      var input = wrap.querySelector('.rc-es-select__input');
      var option = select.options[select.selectedIndex];
      var chosen = option && option.value !== '';
      var text = chosen ? option.text : '';
      if (input.value !== text) input.value = text;
      var placeholder = placeholderText(select);
      if (input.placeholder !== placeholder) input.placeholder = placeholder;
      wrap.classList.toggle('has-value', !!chosen);
    }

    function renderList(wrap, query) {
      var select = wrap.__select;
      var list = wrap.querySelector('.rc-es-select__list');
      var q = normalize(query);
      var html = '';
      var count = 0;
      Array.prototype.forEach.call(select.options, function (option, index) {
        if (!option.value) return;
        if (q && normalize(option.text).indexOf(q) === -1) return;
        var selected = option.value === select.value;
        html +=
          '<li role="option" class="rc-es-select__option' + (selected ? ' is-selected' : '') + '" data-index="' + index + '"' +
          ' aria-selected="' + (selected ? 'true' : 'false') + '">' + option.text + '</li>';
        count += 1;
      });
      list.innerHTML = html || '<li class="rc-es-select__empty">' + wrap.__cfg.empty + '</li>';
      var first = list.querySelector('.is-selected') || list.querySelector('.rc-es-select__option');
      setActive(wrap, first);
      return count;
    }

    function setActive(wrap, item) {
      wrap.querySelectorAll('.rc-es-select__option.is-active').forEach(function (el) { el.classList.remove('is-active'); });
      if (!item) return;
      item.classList.add('is-active');
      item.scrollIntoView({ block: 'nearest' });
    }

    function open(wrap) {
      closeAll(wrap);
      wrap.classList.add('is-open');
      var search = wrap.querySelector('.rc-es-select__search');
      search.value = '';
      /* Focus synchronously, inside the same tap: iOS Safari only opens the keyboard then. */
      search.focus({ preventScroll: true });
      renderList(wrap, '');
      liftIntoView(wrap);
    }

    /* On phones, scroll the form so the field sits at ~20% from the top and the list stays above the keyboard. */
    function liftIntoView(wrap) {
      if (!window.matchMedia('(max-width: 749px)').matches) return;
      var scroller = wrap.closest('#easysell-modal');
      if (!scroller) return;
      /* temporary room under the form so it can scroll up even when the county field is near the end */
      scroller.classList.add('rc-es-lift');
      var lift = function () {
        /* settle the field at ~20% from the top of the visible screen, not at the very top */
        var viewHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
        var offset = wrap.getBoundingClientRect().top - viewHeight * 0.2;
        if (Math.abs(offset) > 4) scroller.scrollBy({ top: offset, behavior: 'smooth' });
      };
      lift();
      /* again once the keyboard has opened and the visible area has shrunk */
      setTimeout(lift, 350);
    }

    function close(wrap) {
      wrap.classList.remove('is-open');
      var scroller = wrap.closest('#easysell-modal');
      if (scroller) scroller.classList.remove('rc-es-lift');
    }

    function closeAll(except) {
      document.querySelectorAll('.rc-es-select.is-open').forEach(function (w) {
        if (w !== except) close(w);
      });
    }

    function choose(wrap, index) {
      var select = wrap.__select;
      var option = select.options[index];
      if (!option) return;
      select.value = option.value;
      select.dispatchEvent(new Event('input', { bubbles: true }));
      select.dispatchEvent(new Event('change', { bubbles: true }));
      syncTrigger(wrap);
      close(wrap);
      wrap.querySelector('.rc-es-select__trigger').focus();
    }

    function enhanceField(cfg) {
      var select = document.querySelector('#easysell-modal #' + cfg.id);
      if (!select) return;
      var wrap = select.parentElement.querySelector('.rc-es-select');
      if (wrap && wrap.__select === select) {
        syncTrigger(wrap);
        return;
      }
      if (wrap) wrap.remove();

      wrap = document.createElement('div');
      wrap.className = 'rc-es-select';
      wrap.__select = select;
      wrap.__cfg = cfg;
      wrap.innerHTML =
        '<div class="rc-es-select__trigger" role="button" tabindex="0" aria-haspopup="listbox">' +
          '<input type="text" class="es-input es-form-control rc-es-select__input" readonly tabindex="-1" aria-hidden="true">' +
          '<i class="fa-solid fa-chevron-down" aria-hidden="true"></i>' +
        '</div>' +
        '<div class="rc-es-select__panel">' +
          '<p class="rc-es-select__title">' + cfg.title + '</p>' +
          '<input type="text" class="rc-es-select__search" placeholder="' + cfg.search + '" autocomplete="off" aria-label="' + cfg.search + '">' +
          '<ul class="rc-es-select__list" role="listbox"></ul>' +
        '</div>';
      select.classList.add('rc-es-native');
      var box = select.parentElement;
      box.classList.add('es-input-group', 'rc-es-select-box');
      if (!box.querySelector('.rc-es-select__icon')) {
        var icon = document.createElement('span');
        icon.className = 'es-input-group-text rc-es-select__icon';
        icon.innerHTML = '<i class="' + cfg.icon + '" aria-hidden="true"></i>';
        box.insertBefore(icon, box.firstChild);
      }
      select.insertAdjacentElement('afterend', wrap);
      select.addEventListener('change', function () { syncTrigger(wrap); });
      syncTrigger(wrap);
    }

    function enhance() {
      FIELDS.forEach(enhanceField);
    }

    document.addEventListener('click', function (event) {
      var target = event.target instanceof Element ? event.target : null;
      if (!target) return;
      var trigger = target.closest('.rc-es-select__trigger');
      if (trigger) {
        var wrap = trigger.closest('.rc-es-select');
        if (wrap.classList.contains('is-open')) close(wrap); else open(wrap);
        return;
      }
      var option = target.closest('.rc-es-select__option');
      if (option) {
        choose(option.closest('.rc-es-select'), parseInt(option.getAttribute('data-index'), 10));
        return;
      }
      if (!target.closest('.rc-es-select__panel')) closeAll(null);
    });

    document.addEventListener('input', function (event) {
      var search = event.target instanceof Element ? event.target.closest('.rc-es-select__search') : null;
      if (search) renderList(search.closest('.rc-es-select'), search.value);
    });

    document.addEventListener('keydown', function (event) {
      var wrap = event.target instanceof Element ? event.target.closest('.rc-es-select') : null;
      if (!wrap) return;
      if (!wrap.classList.contains('is-open')) {
        if ((event.key === 'ArrowDown' || event.key === 'Enter' || event.key === ' ') && event.target.closest('.rc-es-select__trigger')) {
          event.preventDefault();
          open(wrap);
        }
        return;
      }
      var items = Array.prototype.slice.call(wrap.querySelectorAll('.rc-es-select__option'));
      var active = wrap.querySelector('.rc-es-select__option.is-active');
      var index = items.indexOf(active);
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        setActive(wrap, items[Math.min(index + 1, items.length - 1)]);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        setActive(wrap, items[Math.max(index - 1, 0)]);
      } else if (event.key === 'Enter') {
        event.preventDefault();
        if (active) choose(wrap, parseInt(active.getAttribute('data-index'), 10));
      } else if (event.key === 'Escape') {
        event.preventDefault();
        close(wrap);
        wrap.querySelector('.rc-es-select__trigger').focus();
      }
    });

    /* EasySell renders the form on its own schedule: keep enhancing while it changes. */
    var timer = null;
    function schedule() {
      clearTimeout(timer);
      timer = setTimeout(enhance, 30);
    }

    document.addEventListener('DOMContentLoaded', function () {
      var tries = 0;
      var poll = setInterval(function () {
        tries += 1;
        var container = document.querySelector('#easysell-modal #es-form-container');
        if (container && !container.__rcProvinceObserved) {
          container.__rcProvinceObserved = true;
          new MutationObserver(schedule).observe(container, { childList: true, subtree: true, attributes: true, attributeFilter: ['value'] });
          enhance();
        }
        if ((container && container.__rcProvinceObserved) || tries > 40) clearInterval(poll);
      }, 300);
    });
  })();

  /* RoyalCare: remember whether the visitor navigates with the keyboard (for focus rings). */
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Tab') document.documentElement.classList.add('rc-kbd-nav');
  });
  document.addEventListener('pointerdown', function () {
    document.documentElement.classList.remove('rc-kbd-nav');
  });

  /* RoyalCare: "Îți mai recomandăm" carousel inside the cart drawer. */
  (function () {
    function updateNav(track) {
      var box = track.closest('[data-rc-upsell]');
      if (!box) return;
      var prev = box.querySelector('[data-rc-upsell-nav="-1"]');
      var next = box.querySelector('[data-rc-upsell-nav="1"]');
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    }

    document.addEventListener(
      'scroll',
      function (event) {
        var track = event.target;
        if (track instanceof Element && track.matches('[data-rc-upsell-track]')) updateNav(track);
      },
      true
    );

    document.addEventListener('click', function (event) {
      var target = event.target instanceof Element ? event.target : null;
      if (!target) return;

      var navBtn = target.closest('[data-rc-upsell-nav]');
      if (navBtn) {
        var track = navBtn.closest('[data-rc-upsell]').querySelector('[data-rc-upsell-track]');
        var item = track && track.querySelector('.rc-cartupsell__item');
        if (!item) return;
        var step = item.getBoundingClientRect().width + 10;
        track.scrollBy({ left: step * Number(navBtn.getAttribute('data-rc-upsell-nav')), behavior: 'smooth' });
        setTimeout(function () { updateNav(track); }, 450);
        return;
      }

      var addBtn = target.closest('[data-rc-upsell-add]');
      if (!addBtn || addBtn.classList.contains('is-loading')) return;
      event.preventDefault();
      addBtn.classList.add('is-loading');
      addUpsell(addBtn, addBtn.getAttribute('data-rc-upsell-add'));
    });

    function refreshCart(addResponse, events, deferred) {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (deferred && events) {
            deferred.resolve({
              cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
              detail: {
                items: cart.items,
                itemCount: 1,
                source: 'rc-cart-upsell',
                sections: addResponse && addResponse.sections,
                didError: !addResponse || Boolean(addResponse.status)
              }
            });
          } else {
            window.location.reload();
          }
        });
    }

    function addUpsell(button, variantId) {
      Promise.resolve(window.RoyalCareCartEvents || null)
        .then(function (events) {
          var deferred = null;
          if (events && events.CartLinesUpdateEvent) {
            deferred = events.CartLinesUpdateEvent.createPromise();
            button.dispatchEvent(
              new events.CartLinesUpdateEvent({
                action: 'add',
                context: 'dialog',
                lines: [{ merchandiseId: String(variantId), quantity: 1 }],
                promise: deferred.promise
              })
            );
          }

          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: Number(variantId), quantity: 1 }],
              sections: 'cart-drawer-section',
              sections_url: window.location.pathname
            })
          })
            .then(function (r) { return r.json(); })
            .then(function (response) { return refreshCart(response, events, deferred); })
            .then(function () { button.classList.remove('is-loading'); })
            .catch(function () {
              if (deferred) deferred.reject(new Error('Upsell add failed'));
              button.classList.remove('is-loading');
            });
        });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mega-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    /* ---- Mobile overlay: root screen + one sliding screen per category ---- */
    var trigger = document.querySelector('.rc-mnav-trigger');
    var overlay = document.querySelector('.rc-mnav-overlay');
    if (trigger && overlay) {
      document.body.appendChild(overlay);
      var backdrop = overlay.querySelector('.rc-mnav-overlay__backdrop');
      var views = overlay.querySelectorAll('[data-mnav-view]');
      var current = 'root';

      function show(name) {
        current = name;
        views.forEach(function (v) {
          var key = v.getAttribute('data-mnav-view');
          var active = key === name;
          v.classList.toggle('is-active', active);
          v.classList.toggle('is-behind', key === 'root' && name !== 'root');
          v.setAttribute('aria-hidden', active ? 'false' : 'true');
          if (active && name !== 'root') {
            var body = v.querySelector('.rc-mnav__body');
            if (body) body.scrollTop = 0;
          }
        });
        var view = overlay.querySelector('[data-mnav-view="' + name + '"]');
        var focusEl = view && view.querySelector(name === 'root' ? '.rc-mnav__close' : '[data-mnav-back]');
        if (focusEl) setTimeout(function () { focusEl.focus({ preventScroll: true }); }, 60);
      }

      function openMenu() {
        show('root');
        overlay.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
      }

      function closeMenu() {
        overlay.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
        trigger.focus({ preventScroll: true });
      }

      trigger.addEventListener('click', openMenu);
      overlay.addEventListener('click', function (e) {
        if (e.target === backdrop || e.target.closest('.rc-mnav__close')) {
          closeMenu();
          return;
        }
        var go = e.target.closest('[data-mnav-go]');
        if (go) {
          show(go.getAttribute('data-mnav-go'));
          return;
        }
        if (e.target.closest('[data-mnav-back]')) show('root');
      });
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape' || overlay.hidden) return;
        if (current !== 'root') show('root');
        else closeMenu();
      });
    }

    /* ---- Category switching inside the "Produse" panel (Ten / Păr / Corp) ---- */
    document.querySelectorAll('[data-mmenu-categories]').forEach(function (categories) {
      var wrap = categories.closest('.rc-mmenu__panel-inner');
      var categoryPanels = wrap ? wrap.querySelector('[data-mmenu-category-panels]') : null;
      if (!categoryPanels) return;

      function activateCategory(target) {
        categories.querySelectorAll('.rc-mmenu__category').forEach(function (btn) {
          btn.classList.toggle('rc-mmenu__category--active', btn.getAttribute('data-category-target') === target);
        });
        categoryPanels.querySelectorAll('.rc-mmenu__category-panel').forEach(function (panel) {
          panel.classList.toggle('rc-mmenu__category-panel--active', panel.getAttribute('data-category-panel') === target);
        });
      }

      categories.querySelectorAll('.rc-mmenu__category').forEach(function (btn) {
        btn.addEventListener('mouseenter', function () { activateCategory(btn.getAttribute('data-category-target')); });
        btn.addEventListener('focus', function () { activateCategory(btn.getAttribute('data-category-target')); });
        btn.addEventListener('click', function () { activateCategory(btn.getAttribute('data-category-target')); });
      });
    });

    /* ---- Desktop hover mega menu: portal panels to <body> and
       position them under the sticky header so they render full-bleed
       instead of being clipped by the header's `contain: layout`.
       Skipped entirely below the desktop breakpoint: the menu is
       display:none there anyway, so there's no reason to create 5
       fixed-position, transition-heavy layers on mobile. ---- */
    if (!window.matchMedia('(min-width: 990px)').matches) return;

    var headerSection = document.querySelector('.header-section');
    var items = document.querySelectorAll('.rc-mmenu__item');
    var closeTimer = null;

    items.forEach(function (item) {
      var panel = item.querySelector('.rc-mmenu__panel');
      if (panel) document.body.appendChild(panel);
    });

    function positionPanel(panel) {
      var top = headerSection ? headerSection.getBoundingClientRect().bottom : 0;
      panel.style.top = Math.round(top) + 'px';
    }

    function closeAllPanels() {
      items.forEach(function (el) { el.classList.remove('rc-mmenu__item--open'); });
      document.querySelectorAll('.rc-mmenu__panel').forEach(function (p) {
        p.classList.remove('rc-mmenu__panel--open');
      });
    }

    function openItem(item) {
      clearTimeout(closeTimer);
      closeAllPanels();
      var panel = document.querySelector('.rc-mmenu__panel[data-panel="' + item.getAttribute('data-menu-key') + '"]');
      if (panel) {
        positionPanel(panel);
        item.classList.add('rc-mmenu__item--open');
        panel.classList.add('rc-mmenu__panel--open');
      }
    }

    function scheduleClose() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(closeAllPanels, 150);
    }

    items.forEach(function (item) {
      if (!item.getAttribute('data-menu-key')) return;
      item.addEventListener('mouseenter', function () { openItem(item); });
      item.addEventListener('mouseleave', scheduleClose);
      var panel = document.querySelector('.rc-mmenu__panel[data-panel="' + item.getAttribute('data-menu-key') + '"]');
      if (panel) {
        panel.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
        panel.addEventListener('mouseleave', scheduleClose);
      }
    });

    window.addEventListener('resize', function () {
      document.querySelectorAll('.rc-mmenu__panel').forEach(positionPanel);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
